export default __webpack_public_path__ + "static/media/Plot the Twist.9ca50256.jpg";